export const SKIN_GENDER = [
    {
        key: 'male',
        label: 'เพศชาย',
        active: false,
        image: 'male'
    },
    {
        key: 'female',
        label: 'เพศหญิง',
        active: false,
        image: 'female'
    }
]

export const EXCLUDE_AGE_SUFFIX = ['18 หรือต่ำกว่า', '46+']

export const SKIN_AGE = [
    {
        key: '18',
        label: '18 หรือต่ำกว่า',
        active: false,
        upperLimit: 18
    },
    {
        key: '19-22',
        label: '19-22',
        active: false,
        upperLimit: 22
    },
    {
        key: '23-26',
        label: '23-26',
        active: false,
        upperLimit: 26
    },
    {
        key: '27-30',
        label: '27-30',
        active: false,
        upperLimit: 30
    },
    {
        key: '31-35',
        label: '31-35',
        active: false,
        upperLimit: 35
    },
    {
        key: '36-45',
        label: '36-45',
        active: false,
        upperLimit: 45
    },
    {
        key: '46',
        label: '46+',
        active: false,
        upperLimit: 100
    },
]

export const SECTION_ORDER = ['M1', 'M2', 'M3', 'M4', 'M5'];

export const SKIN_ASSESSMENT_QUESTION_TEMPLATE = {
    M1: {
        key: 'skin',
        progress_tracker: 0,
        section: 'Skin Type',
        question_count: 0,
        bgClassName: 'm1-gradient',
        header: "แบบประเมินสภาพผิว",
        qTitleBgClassName: 'm1-title',
        selectedClassName: 'm1-selected',
        selectedCard: 'm1-btn',
    },
    M2: {
        key: 'dark-spots',
        progress_tracker: 1,
        section: 'Dark Spots',
        question_count: 0,
        bgClassName: 'm2-gradient',
        header: "แบบประเมินปัญหาผิวไม่สม่ำเสมอ",
        qTitleBgClassName: 'm2-title',
        selectedClassName: 'm2-selected',
        selectedCard: 'm2-btn'
    },
    M3: {
        key: 'wrinkles',
        progress_tracker: 2,
        section: 'Wrinkle',
        question_count: 0,
        bgClassName: 'm3-gradient',
        header: "แบบประเมินปัญหาริ้วรอย",
        qTitleBgClassName: 'm3-title',
        selectedClassName: 'm3-selected',
        selectedCard: 'm3-btn'
    },
    M4: {
        key: 'loose',
        progress_tracker: 3,
        section: 'Loose',
        question_count: 0,
        bgClassName: 'm4-gradient',
        header: "แบบประเมินปัญหาผิวหย่อนคล้อย",
        qTitleBgClassName: 'm4-title',
        selectedClassName: 'm4-selected',
        selectedCard: 'm4-btn'
    },
    M5: {
        key: 'others',
        progress_tracker: 4,
        section: 'Others',
        question_count: 0,
        bgClassName: 'm5-gradient',
        header: "แบบประเมินปัญหาผิวอื่น ๆ",
        qTitleBgClassName: 'm5-title',
        selectedClassName: 'm5-selected',
        selectedCard: 'm5-btn'
    }
};

export const SKIN_ASSESSMENT_QUESTION_TEMPLATE_M1 = {
    DEFAULT: {
        type: 'CARD_CAROUSEL',
        options: ['M1.A', 'M1.B', 'M1.C', 'M1.D'],
    },
    NOT_SURE: {
        type: 'CARD_GRID',
        label: 'M1.E',
        followup: true,
    },
};

export const HNW_ASSESSMENT_PATH_KEYS = {
    '6LifestyleKeysAssesment': 'pathHnWAssessmentHome',
    'skinAssessment': 'pathHnWSkinAssessment'
}

export const ASSESSMENT_LABEL = {
    LIFESTYLE_ASSESSMENT: '6LifestyleKeysAssesment',
    SKIN_ASSESSMENT: 'skinAssessment',
    STRESS_ASSESSMENT: 'stressAssessment',
}

export const SKIN_ASM_CONSTANTS = {
    CHOOSE_BTN: 'เลือก',
    FOOTER_CONDITION_LINK_TEXT: 'ยอมรับเงื่อนไขการทำแบบประเมินสภาพผิว',
    START_ASSESSMENT_BTN_TEXT: 'ทำแบบประเมิน',
    START_ANONYMOUS_LINK_TEXT: 'ทำแบบประเมินไม่ระบุตัวตน',
    START_ASSESSMENT_POPUP_TITLE: 'เริ่มทำแบบประเมิน',
    PENDING_ASSESSMENT_POPUP_MESSAGE: 'คุณมีแบบประเมินที่ทำค้างไว้ ต้องการทำต่อหรือไม่?',
    CONTINUE_POPUP_BTN_TEXT: 'ทำต่อ',
    START_NEW_BTN_TEXT: 'เริ่มทำใหม่',
    USER_ERROR_POPUP_TITLE: 'ขออภัย',
    USER_ERROR_POPUP_MESSAGE: 'คุณไม่ได้รับสิทธิ์  \nในการทำแบบประเมินสภาพผิว',
    USER_POPUP_CLOSE_BTN_TEXT: 'ปิด',
    GENDER: 'GENDER',
    AGE: 'AGE',
    M1: 'M1',
    M1E: 'M1.E',
    UPLOAD_FROM_GALLERY: 'แตะเพื่ออัปโหลดรูปจากคลัง',
    IMAGE_SIZE_DESC: 'JPG,PNG (ขนาดไม่เกิน 5 MB)',
    CAMERA_UPLOAD_BTN: 'เปิดกล้อง',
    SKIP_UPLOAD: 'ข้าม ไม่ต้องการเก็บรูป',
    ASSESSMENT_KEY: 'SKIN_ASSESSMENT',
    ASSESSMENT_INSTANCE: 'ASSESSMENT',
    USER_AGE_QUES: 'คุณอายุเท่าไหร่?',
    USER_GENDER_QUES: 'คุณคือเพศใด?',
    ANONYMOUS_HEADING_TEXT: '(ไม่ระบุตัวตน)',
    GOTO_RESULT_PAGE_TEXT: 'ดูประวัติ',
}

export const SKIN_TYPE_MAP = {
    A: 'dry',
    B: 'oily',
    C: 'combination',
    D: 'normal',
    E: 'notsure',
}

export const SKIN_RESULT_USER_DETAILS = [
    {
        label: 'เพศ',
        value: 'gender'
    },
    {
        label: 'อายุ',
        value: 'age',
        suffix: 'ปี'
    },
    {
        label: 'สภาพผิว',
        value: 'skinType'
    }
]

export const USER_DETAILS_MAPPER = {
    FEMALE: 'หญิง',
    MALE: 'ชาย',
    DRY: 'แห้ง',
    OILY: 'มัน',
    COMBINATION: 'ผสม',
    NORMAL: 'ธรรมดา'
}

export const SKIN_MAPPER = {
    dry: {
        label: 'สภาพผิว (แห้ง)',
        graphlabel: 'สภาพผิว (แห้ง)',
        recommendLabel: 'สินค้าแนะนำสภาพผิว',
        image: 'skin',
        maxScore: 12
    },
    oily: {
        label: 'สภาพผิว (มัน)',
        graphlabel: 'สภาพผิว (มัน)',
        recommendLabel: 'สินค้าแนะนำสภาพผิว',
        image: 'skin',
        maxScore: 14
    },
    combination: {
        label: 'สภาพผิว (ผสม)',
        graphlabel: 'สภาพผิว (ผสม)',
        recommendLabel: 'สินค้าแนะนำสภาพผิว',
        image: 'skin',
        maxScore: 7
    },
    normal: {
        label: 'สภาพผิว (ธรรมดา)',
        graphlabel: 'สภาพผิว (ธรรมดา)',
        recommendLabel: 'สินค้าแนะนำสภาพผิว',
        image: 'skin',
        maxScore: 10
    },
    'dark-spots': {
        label: 'ปัญหาผิวไม่สม่ำเสมอ',
        graphlabel: 'จุดด่างดำ',
        recommendLabel: 'สินค้าแนะนำปัญหาไม่สม่ำเสมอ',
        image: 'uneven',
        maxScore: 12
    },
    wrinkles: {
        label: 'ปัญหาริ้วรอย',
        graphlabel: 'ริ้วรอย',
        recommendLabel: 'สินค้าแนะนำปัญหาริ้วรอย',
        image: 'wrinkle',
        maxScore: 8
    },
    loose: {
        label: 'ปัญหาผิวหย่อนคล้อย',
        graphlabel: 'หย่อนคล้อย',
        recommendLabel: 'สินค้าแนะนำปัญหาผิวหย่อนคล้อย',
        image: 'sagging',
        maxScore: 12
    },
    'others': {
        label: 'ปัญหาผิวอื่น ๆ',
        graphlabel: 'อื่นๆ',
        recommendLabel: 'สินค้าแนะนำปัญหาผิวอื่น ๆ',
        image: 'other',
        maxScore: 16
    }

}

export const ANONYMOUS_QUESTION_TEMPLATE = {
    GENDER: {
        question_id: 'gender',
        question_label: 'GENDER',
    },
    AGE: {
        question_id: 'age',
        question_label: 'AGE',
    },
};

export const ASSESSMENT_MODES = {
    anonymous: 'ANONYMOUS',
    normal: 'NORMAL'
}

export const ASSESSMENT_FINAL_PAYLOAD_KEY = 'ASSESSMENT_FINAL_PAYLOAD';

export const ASSESSMENT_IMAGE_UPLOAD_PROPS = 'ASSESSMENT_IMAGE_UPLOAD_PROPS';
export const ASSESSMENT_IMAGE_URL = 'ASSESSMENT_IMAGE_URL';
export const NORMAL = 'normal';

export const SKIN_ASSESSMENT_QUESTION_TYPES = {
    cardSkinType: "Card - Skin Type",
    card: "Card",
    bar: "Bar",
    textSingle: "TextSingle",
    textMultiple: "TextMultiple",
}
